export default {
    path: '/resumes',
    component: () => import('source/pages/root/ResumesPageGroup.vue'),
    meta: {
        title: 'HQZen - Resumes',
        loginRequired: false
    },

     children: [
            {
                path: '',
                name: 'resumes',
                component: () => import('source/pages/resumes/Resumes.vue'),
                props: true,
                meta: {
                    title: 'HQZen Resumes',
                    canDisplayGlobalModals: false
                },
            },
            {
                path: 'resume/:id',
                name: 'resume-details',
                component: () => import('source/pages/resumes/ResumeDetail.vue'),
                props: true,
                meta: {
                    title: 'HQZen Resume Detail',
                    canDisplayGlobalModals: false,
                }
            }
        ]
};
